<template>
  <div class="service-ecosystem">
    <div class="content-center">
      <div class="module-header">
        <div class="module-title">强大的服务体系</div>
      </div>
      <div class="module-body">
        <div class="module-body-left">
          <div class="title-tag">遍布全国的服务交付团队，解决您的燃眉之急</div>
          <div class="entity-active">
            <div class="entity-active-tag">{{ entityActive.province }}</div>
            <div class="entity-active-content">
              <div class="entity-active-title">{{ entityActive.team }}</div>
              <div class="entity-active-text">{{ entityActive.serviceTypes }}</div>
            </div>
          </div>
          <div
            class="entity-item"
            v-for="item in entityList"
            :key="item.province"
            :class="{ 'is-left': item.isLeft, active: item.province == entityActive.province }"
            :style="{ left: `${item.left}px`, bottom: `${item.bottom}px` }"
            @click="handleSelectEntity(item)"
          >{{ item.province }}</div>
        </div>
        <div class="module-body-right">
          <div class="title-tag">最新落地订单</div>
          <div class="order-table">
            <div class="table-header">
              <div class="table-th" v-for="col in columns" :key="col.prop" :style="{ width: `${col.width}px` }">{{ col.label }}</div>
            </div>
            <div class="table-body">
              <div class="table-body-inner">
                <div class="table-row" v-for="(row, index) in renderList" :key="index">
                  <div class="table-td" v-for="col in columns" :key="col.prop" :style="{ width: `${col.width}px` }">{{ row[col.prop] }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      entityActive: {},
      entityList: [
        { province: '江苏省', team: '江苏省服务团队', left: 499, bottom: 242, serviceTypes: '投标服务、出现场服务、安装服务、管家服务、设计服务、套餐类服务、图文制作、解决方案、维保服务' },
        { province: '新疆维吾尔自治区', team: '新疆维吾尔自治区服务团队', left: 158, bottom: 290, isLeft: true, serviceTypes: '投标服务、安装服务、管家服务、设计服务、图文制作、解决方案' },
        { province: '内蒙古自治区', team: '内蒙古自治区服务团队', left: 404, bottom: 298, isLeft: true, serviceTypes: '出现场服务、实施管理服务、设计服务、套餐类服务' },
        { province: '北京市', team: '北京市服务团队', left: 454, bottom: 304, serviceTypes: '投标服务、出现场服务、安装服务、实施管理服务、管家服务、图文制作、解决方案' },
        { province: '宁夏回族自治区', team: '宁夏回族自治区服务团队', left: 368, bottom: 252, isLeft: true, serviceTypes: '套餐类服务、图文制作、解决方案' },
        { province: '河南省', team: '河南省服务团队', left: 455, bottom: 245, isLeft: true, serviceTypes: '投标服务、出现场服务、安装服务、实施管理服务、管家服务、设计服务、套餐类服务、图文制作' },
        { province: '山东省', team: '山东省服务团队', left: 482, bottom: 271, serviceTypes: '实施管理服务、设计服务、解决方案' },
        { province: '上海市', team: '上海市服务团队', left: 554, bottom: 230, serviceTypes: '出现场服务、安装服务、实施管理服务、套餐类服务、图文制作' },
        { province: '四川省', team: '四川省服务团队', left: 356, bottom: 164, isLeft: true, serviceTypes: '投标服务、管家服务、设计服务、解决方案' },
        { province: '安徽省', team: '安徽省服务团队', left: 504, bottom: 202, isLeft: true, serviceTypes: '投标服务、出现场服务、实施管理服务、套餐类服务、管家服务、设计服务、图文制作、解决方案' },
        { province: '江西省', team: '江西省服务团队', left: 491, bottom: 168, isLeft: true, serviceTypes: '安装服务、设计服务、套餐类服务' },
        { province: '贵州省', team: '贵州省服务团队', left: 408, bottom: 114, isLeft: true, serviceTypes: '投标服务、出现场服务、安装服务、实施管理服务、管家服务、解决方案' },
        { province: '云南省', team: '云南省服务团队', left: 362, bottom: 79, isLeft: true, serviceTypes: '出现场服务、设计服务、图文制作、解决方案' },
        { province: '广东省', team: '广东省服务团队', left: 497, bottom: 98, serviceTypes: '投标服务、安装服务、实施管理服务、套餐类服务、管家服务、设计服务、图文制作' },
      ],
      columns: [
        { label: '服务类型', prop: 'type', width: 130 },
        { label: '所在区域', prop: 'scheme', width: 150 },
        { label: '金额(元)', prop: 'amount', width: 100 },
        { label: '用户名', prop: 'user', width: 120 },
      ],
      orderList: [
        { type: '投标服务', scheme: '山东省', amount: '12500', user: '李*云企业' },
        { type: '出现场服务', scheme: '江苏省', amount: '8920', user: '王**云企业' },
        { type: '安装服务', scheme: '上海市', amount: '87650', user: '陈*云企业' },
        { type: '实施管理服务', scheme: '河南省', amount: '23450', user: '赵**云企业' },
        { type: '套餐类服务', scheme: '安徽省', amount: '56890', user: '吴*云企业' },
        { type: '管家服务', scheme: '四川省', amount: '37200', user: '周**云企业' },
        { type: '设计服务', scheme: '广东省', amount: '69450', user: '徐*云企业' },
        { type: '图文制作', scheme: '云南省', amount: '18720', user: '孙**云企业' },
        { type: '解决方案', scheme: '贵州省', amount: '9580', user: '马*云企业' },
        { type: '投标服务', scheme: '新疆维吾尔自治区', amount: '42690', user: '朱**云企业' },
        { type: '出现场服务', scheme: '内蒙古自治区', amount: '29540', user: '胡*云企业' },
        { type: '安装服务', scheme: '北京市', amount: '7320', user: '林**云企业' },
        { type: '实施管理服务', scheme: '宁夏回族自治区', amount: '31870', user: '郭*云企业' },
        { type: '套餐类服务', scheme: '江西省', amount: '58240', user: '何**云企业' },
        { type: '管家服务', scheme: '山东省', amount: '16950', user: '高*云企业' },
        { type: '设计服务', scheme: '江苏省', amount: '82560', user: '罗**云企业' },
        { type: '图文制作', scheme: '上海市', amount: '5780', user: '郑*云企业' },
        { type: '解决方案', scheme: '河南省', amount: '63420', user: '梁**云企业' },
        { type: '投标服务', scheme: '安徽省', amount: '47890', user: '谢*云企业' },
        { type: '出现场服务', scheme: '四川省', amount: '38560', user: '宋**云企业' },
        { type: '安装服务', scheme: '广东省', amount: '52180', user: '唐*云企业' },
        { type: '实施管理服务', scheme: '云南省', amount: '21940', user: '韩**云企业' },
        { type: '套餐类服务', scheme: '贵州省', amount: '79350', user: '冯*云企业' },
        { type: '管家服务', scheme: '新疆维吾尔自治区', amount: '45620', user: '董**云企业' },
        { type: '设计服务', scheme: '内蒙古自治区', amount: '32780', user: '萧*云企业' },
        { type: '图文制作', scheme: '北京市', amount: '60430', user: '程*云企业' },
        { type: '解决方案', scheme: '宁夏回族自治区', amount: '17590', user: '曹**云企业' },
        { type: '投标服务', scheme: '江西省', amount: '51270', user: '袁*云企业' },
        { type: '出现场服务', scheme: '山东省', amount: '7310', user: '邓*云企业' },
        { type: '安装服务', scheme: '江苏省', amount: '36850', user: '许**云企业' },
      ],
      renderList: []
    }
  },
  created() {
    this.entityActive = this.entityList[0];
    this.renderList = this.orderList.concat(this.orderList);
  },
  methods: {
    handleSelectEntity(item) {
      this.entityActive = item;
    }
  }
};
</script>

<style lang="less" scoped>
.service-ecosystem {
  padding: 64px 0;

  .content-center {
    .module-body {
      margin-top: 69px;
      display: flex;
      justify-content: space-between;
      align-content: flex-start;
      .title-tag {
        display: inline-block;
        padding: 0 20px 0 28px;
        font-family: @font-medium;
        font-size: 18px;
        line-height: 44px;
        background-color: rgba(255, 130, 1, 0.1);
        border-radius: 0 14px 0 14px;
        position: relative;
        &::before {
          content: '';
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background-color: @primary-color;
          position: absolute;
          left: 16px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .module-body-left {
        width: 620px;
        height: 620px;
        background-image: url('@/assets/img/service/ServiceSystem/bg_map.png');
        background-position: center bottom;
        background-repeat: no-repeat;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        position: relative;
        .entity-active {
          margin-top: 24px;
          padding: 22px 24px;
          border-radius: 4px;
          border: 1px solid @primary-color;
          background-color: rgba(255, 130, 1, 0.1);
          display: flex;
          align-items: flex-start;
          .entity-active-tag {
            padding: 0 16px;
            background: linear-gradient(90deg, #FF9B02 0%, #FF8100 100%);
            border-radius: 4px;
            font-family: @font-medium;
            font-size: 14px;
            color: #fff;
            line-height: 28px;
          }
          .entity-active-content {
            margin-left: 24px;
            padding-left: 27px;
            .entity-active-title {
              font-family: @font-medium;
              position: relative;
              &::before {
                content: '';
                width: 20px;
                height: 20px;
                background-image: url('@/assets/img/service/ServiceSystem/icon_team.png');
                background-size: 100% 100%;
                position: absolute;
                left: -27px;
                top: 50%;
                transform: translateY(-50%);
              }
            }
            .entity-active-text {
              width: 286px;
              margin-top: 6px;
              text-align: justify;
              font-size: 14px;
              color: #666;
              line-height: 22px;
            }
          }
        }
        .entity-item {
          padding: 0 11px;
          background-color: rgba(255, 130, 1, 0.1);
          border-radius: 6px 6px 6px 0;
          line-height: 28px;
          font-size: 14px;
          cursor: pointer;
          user-select: none;
          position: absolute;
          &::after {
            content: '';
            width: 24px;
            height: 24px;
            background-image: url('@/assets/img/service/ServiceSystem/icon_point.png');
            background-size: 100% 100%;
            position: absolute;
            left: 0;
            bottom: 0;
            transform: translate(-50%, 50%);
          }
          &.is-left {
            transform: translateX(-100%);
            border-radius: 6px 6px 0 6px;
            &::after {
              left: auto;
              right: 0;
              transform: translate(50%, 50%);
            }
          }
          &.active {
            background-color: rgba(255, 130, 1, 1);
            color: #fff;
          }
        }
      }
      .module-body-right {
        .order-table {
          margin-top: 75px;
          .table-header,
          .table-row {
            display: flex;
          }
          .table-header {
            .table-th {
              padding: 0 12px;
              line-height: 40px;
              background-color: rgba(255, 130, 1, 0.10);
              font-family: @font-medium;
              font-size: 14px;
            }
          }
          .table-body {
            height: calc(41px * 10);
            overflow: hidden;
            .table-body-inner {
              animation: roll 40s linear infinite;
              &:hover {
                animation-play-state: paused;
              }
              @keyframes roll {
                0% {
                  transform: translateY(0%);
                }
                100% {
                  transform: translateY(-50%);
                }
              }
              .table-row {
                border-top: 1px solid #EDEFF2;
                .table-td {
                  padding: 0 12px;
                  line-height: 40px;
                  background-color: #fff;
                  font-size: 14px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
